import React from "react"

// Components
import ToolTypeContent from "./ToolTypeContent"
import ToolTypeHeader from "./ToolTypeHeader"

const ToolType = ({ section }) => {
  if (!section) {
    return null
  }

  return (
    <div className={`ToolType ${section.uuid}`}>
      <ToolTypeHeader section={section} />
      <ToolTypeContent section={section} />
    </div>
  )
}

export default ToolType
